<div class="row mb-3 mt-2">
  <div class="col-8 col-md-3">
    <button class="btn btn-secondary text-white m-r-10" (click)="activeChange.emit(false)">Atras</button>
   </div>

  <div class="col-4 col-md-9 d-flex justify-content-end">
    <button class="btn btn-success text-white m-r-10" (click)="openModalAccount()">Agregar Cuenta</button>
  </div>
</div>

<div [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x, 'position': 'absolute'}">
  <app-context-menu #contextMenu></app-context-menu>
</div>


<mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" cdkDropListData="dataSource" cdkDropList (cdkDropListDropped)="drop($event)"
  (scroll)="onTableScroll()" >
  <ng-container matColumnDef="order">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 65px;">Orden </mat-header-cell>
    <mat-cell    *matCellDef="let element" style="flex: 0 0 65px;"  (contextmenu)="onRightClick($event, element)">
      <span ><i class="fa-solid fa-grip-vertical"></i></span>&nbsp;&nbsp;
      <span>{{element.order}}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="isActive">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 65px;">Activo </mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 65px;" (contextmenu)="onRightClick($event, element)">
      <input #isActive class="form-check-input" type="checkbox" [checked]="element.isActive"
        (change)="updateAccountPlan(element,'isActive',isActive.checked)"> </mat-cell>
  </ng-container>
  <ng-container matColumnDef="isTaxable">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 85px;">Imponible</mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 85px;" (contextmenu)="onRightClick($event, element)">
      <input class="form-check-input" #isTaxable type="checkbox" [checked]="element.isTaxable"
        (change)="updateAccountPlan(element,'isTaxable',isTaxable.checked)"></mat-cell>
  </ng-container>
  <ng-container matColumnDef="accountCode">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 90px;"> Codigo </mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 90px;"
      (contextmenu)="onRightClick($event, element)">{{element.accountCode}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="displayName">
    <mat-header-cell *matHeaderCellDef> Nombre para Mostrar </mat-header-cell>
    <mat-cell *matCellDef="let element" (click)="enableEditing(element)" class="editable-span text-nowrap"
      (contextmenu)="onRightClick($event, element)">
      @if(!element.isEditingDisplayName){
      <span (click)="enableEditing(element,'DisplayName')">
        {{ element.displayName || '---' }}
      </span>
      }
      @if(element.isEditingDisplayName){
      <input #input type="text" class="form-control form-control-sm" [value]="element.displayName"
        (blur)="updateAccountPlan(element, 'displayName', input.value);element.isEditingDisplayName = false; element.displayName = input.value"
        (keydown.enter)="updateAccountPlan(element, 'displayName', input.value);element.isEditingDisplayName = false; element.displayName = input.value" />
      }
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="hint">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 250px;">Info de Cuenta</mat-header-cell>
    <mat-cell *matCellDef="let element;let i =index" (click)="enableEditing(element,'Hint')" class="editable-span"
      style="flex: 0 0 250px;" (contextmenu)="onRightClick($event, element)">
      @if(!element.isEditingHint){
      <span>
        {{ element?.hint?.slice(0,60)|| '-' }}
      </span>
      }
      @if(element.isEditingHint){
      <div class="textarea-container">
        <textarea #input class="editable-textarea form-control form-control-sm" [value]="element.hint"
          (blur)="updateAccountPlan(element, 'hint', input.value); element.isEditingHint = false;element.hint=input.value"
          (keydown.enter)="updateAccountPlan(element, 'hint', input.value); element.isEditingHint = false;element.hint=input.value"
          (focus)="autoGrow($event)" (input)="autoGrow($event)" rows="1">
          </textarea>
      </div>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="calculation">
    <mat-header-cell *matHeaderCellDef class="text-nowrap" style="flex: 0 0 250px;"> Formula</mat-header-cell>
    <mat-cell *matCellDef="let element;let i =index" (click)="enableEditing(element,'Cal')" class="editable-span"
      style="flex: 0 0 250px;" (contextmenu)="onRightClick($event, element)">
      @if(!element.isEditingCal){
      <span>
        {{ element?.calculation?.slice(0,60)|| '-' }}
      </span>
      }
      @if(element.isEditingCal){
      <div class="textarea-container">
        <textarea #input class="editable-textarea form-control form-control-sm" [value]="element.calculation"
          (blur)="updateAccountPlan(element, 'calculation', input.value); element.isEditingCal = false;element.calculation=input.value"
          (keydown.enter)="updateAccountPlan(element, 'calculation', input.value); element.isEditingCal = false;element.calculation=input.value"
          (focus)="autoGrow($event)" (input)="autoGrow($event)" rows="1">
          </textarea>
      </div>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="block">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 80px;"> Bloquear </mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 80px;" (contextmenu)="onRightClick($event, element)">
      <input #block class="form-check-input" type="checkbox" [checked]="element.block"
        (change)="updateAccountPlan(element,'block',block.checked)"></mat-cell>
  </ng-container>
  <ng-container matColumnDef="fmrApplied">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px;">Depende de FMR</mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 100px;" (contextmenu)="onRightClick($event, element)">
      <input class="form-check-input" #fmrApplied type="checkbox" [checked]="element.fmrApplied"
        (change)="updateAccountPlan(element,'fmrApplied',fmrApplied.checked)"></mat-cell>
  </ng-container>

  <ng-container matColumnDef="setting">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px;"> <i class="fa-solid fa-gear"></i></mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 100px;" (contextmenu)="onRightClick($event, element)">
      @if(element.account_type!=1){
      <button class="btn btn-outline-danger btn-xs" (click)="deleteAccountPlan(element)"><i
          class="fa-solid fa-trash"></i>
      </button>
    }
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></mat-row>
</mat-table>

<br>



<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Agregar Cuenta</h5>
    <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
      <span></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formAccountPlanVersion">
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Nombre Personalizado</label>
        <div class="col-md-8">
          <input type="text" #nameInput
            [class.is-invalid]="formAccountPlanVersion.get('displayName').invalid&&formAccountPlanVersion.get('displayName').touched"
            (click)="formAccountPlanVersion.get('displayName').markAsUntouched();" placeholder="Nombre Personalizado"
            (focus)="formAccountPlanVersion.get('displayName').markAsUntouched();" formControlName="displayName"
            name="displayName" class="form-control" tabindex="2" />
          @if(formAccountPlanVersion.get('displayName')?.errors?.required &&
          formAccountPlanVersion.get('displayName').touched){
          <div><small class="text-danger">Nombre es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Cuenta</label>
        <div class="col-md-8">
          <ng-select #ngSelect [hideSelected]="true" [items]="account" bindLabel="nameCode" [closeOnSelect]="true"
            [dropdownPosition]="'bottom'" bindValue="code" placeholder="Escribe una cuenta o codigo"
            formControlName="accountCode" name="accountCode"  tabindex="1"
            (close)="closeNgSelect(ngSelect)">
          </ng-select>
          @if(formAccountPlanVersion.get('accountCode')?.errors?.required &&
          formAccountPlanVersion.get('accountCode').touched){
          <div><small class="text-danger">Cuenta es requerida.</small></div>
          }
        </div>
      </div>&nbsp;

      <div class="form-group row">
        <label class="col-md-4 col-form-label">Inf Campo</label>
        <div class="col-md-8">
          <input type="text"
            [class.is-invalid]="formAccountPlanVersion.get('hint').invalid&&formAccountPlanVersion.get('hint').touched"
            (click)="formAccountPlanVersion.get('hint').markAsUntouched();" placeholder="Inf Campo"
            (focus)="formAccountPlanVersion.get('hint').markAsUntouched();" formControlName="hint" name="hint"
            class="form-control" tabindex="2" />
          @if(formAccountPlanVersion.get('hint')?.errors?.required && formAccountPlanVersion.get('hint').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;

      <div class="form-group row">
        <label class="col-md-4 col-form-label">Formula</label>
        <div class="col-md-8">
          <textarea #input formControlName="calculation" name="calculation" class="form-control form-control-sm"
            (focus)="autoGrow($event)" (input)="autoGrow($event)" rows="1" placeholder="Formula">
        </textarea>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click'); resetForm()"><i
        class="fas fa-times"></i>&nbsp; Cerrar</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="submitNewAccount()"
      [disabled]="formAccountPlanVersion.pristine&&!formAccountPlanVersion.valid||!formAccountPlanVersion.valid"
      tabindex="4"><i class="fas fa-save"></i>&nbsp;Guardar</button>


  </div>

</ng-template>